import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authService } from "../../services/auth";

const initialState = {
  msg: "",
  user: null,
  token: "",
  loading: false, 
  error: "",
  isLoggedIn: false,
};

export const loginInUser = createAsyncThunk("signIn", async (playload) => {
  try {
    const response = await authService.SignIn(playload);
    
    if (!response) {
      throw new Error('No response from auth service');
    }
    
    const { data, status } = response;
    data.status = status;
    return data;
  } catch (error) {
    throw error;
  }
});

export const registerInUser = createAsyncThunk("Register", async (playload) => {
  try {
    const response = await authService.Register(playload);
    
    if (!response) {
      throw new Error('No response from registration service');
    }
    const { data, status } = response;
    data.status = status;
    return data;
  } catch (error) {
    // Redux registerInUser error
    throw error;
  }
});

export const forgotPassword = createAsyncThunk("forgot_password", async (playload) => {
  const { data, status } = await authService.ForgotPassword(playload);
  data.status = status;
  return data;
});

export const changePassword = createAsyncThunk("change_password", async (playload) => {
  const { data, status } = await authService.ChangePassword(playload);
  data.status = status;
  return data;
});


const AuthSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    logoutAuth: (state) => {
      state.token = null;
      localStorage.clear();
      state.msg = "";
      state.user = null;
      state.loading = false;
      state.error = null;
      state.isLoggedIn = false;
    },
    setSingleUser: (state, { payload }) => {
      state.user = payload;
      state.isLoggedIn = true;
      // Store user data in localStorage when setting user
      if (payload) {
        localStorage.setItem("userData", JSON.stringify(payload));
      }
    },
    checkLoggedIn: (state, { payload }) => {
      state.isLoggedIn = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginInUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginInUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload.success) {
          state.user = payload.data;
          state.token = payload.data.token;
          state.isLoggedIn = true;
          localStorage.setItem("userAccess", `Bearer ${payload.data.token}`);
          // Store user data separately for persistence
          localStorage.setItem("userData", JSON.stringify(payload.data));
        } else {
          state.error = payload.msg || "Login failed";
        }
      })
      .addCase(loginInUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "An error occurred";
      })
      .addCase(registerInUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerInUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (payload.success) {
          state.user = payload.data;
          state.token = payload.data.token;
          state.isLoggedIn = true;
          localStorage.setItem("userAccess", `Bearer ${payload.data.token}`);
          // Store user data separately for persistence
          localStorage.setItem("userData", JSON.stringify(payload.data));
        } else {
          state.error = payload.msg || "Registration failed";
        }
      })
      .addCase(registerInUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Registration failed";
      });
  }
});

export const { logoutAuth, checkLoggedIn,setSingleUser  } = AuthSlice.actions;
export default AuthSlice.reducer;
